import React, { useState } from "react";
import { Accordion } from "react-bootstrap";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OtpInput from "react-otp-input";

const PaymentHistroyOverlay = ({ overlay, setOverlay }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [activeCard, setActiveCard] = useState(0);
  const [cardClose, setCardClose] = useState(true);
  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };

  const [activeKeys, setActiveKeys] = useState([
    "0",
    "3",
    "6",
    "7",
    "8",
    "9",
    // "10",
    // "11",
    "17",
    "20",
  ]); // Initially open accordions

  const [otp, setOtp] = useState("");
  return (
    <div>
      <div className={`overlay ${overlay ? "d-none" : null}  `}></div>

      <div
        className={`overlayContent overflow-auto ${
          overlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center ps-4 py-3">
          <div className="fw-600 fs-16px d-flex align-items-center gap-2 ">
            <i
              className="icon-close_circle_fill fs-5 cursor-pointer"
              onClick={() => setOverlay(true)}
            ></i>
            Invoice FY (var) |{" "}
            <span className="text-warning-100 fs-16px fw-500">
              Total invoice 20
            </span>
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          {/* ======================card view=========================== */}

          <div className="head m-0 p-0 d-flex justify-content-between align-items-center">
            <span className="fw-500 fs-14px">Invoice 01</span>
            <span className="fw-500 fs-14px d-flex align-items-center gap-2">
              Showing 1/20
              <span>
                <i className="icon-keyboard_arrow_left fw-500 fs-16px"></i>
                <i className="icon-keyboard_arrow_right fw-500 fs-16px"></i>
              </span>
            </span>
          </div>

          <div className="bg-white border-Prime-100 rounded-3 p-0 m-0 px-2 ">
            {/* ================================card body========================= */}

            <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
              Invoice Details
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order No:
                </span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order Date:
                </span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">
                  Sanction Order Amount:
                </span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher No:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher Date:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Voucher Amount:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Vendor Name</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Account No.</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">IFSC</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60 d-flex justify-content-between align-items-center">
                  Bank <i className="icon-info fs-16px"></i>{" "}
                </span>
                <span className="fs-14px fw-500">21654</span>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Invoice No:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Invoice Date:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <span className="fs-12px text-black-60">Payment Type:</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex align-items-center gap-1 p-2">
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
                <i className="icon-picture_as_pdf fs-18px text-danger-100"></i>
              </div>
            </div>

            <div className="row px-2">
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Taxable Amount</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Invoice Amount</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Sanctioned</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Deduction</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">with-held</span>
                <span className="fs-14px fw-500">21654</span>
              </div>
              <div className="col m-0 p-0 d-flex gap-1 p-2 d-flex flex-column">
                <span className="fs-12px text-black-60">Payment Amount</span>
                <span className="fs-14px fw-500 text-success-100">21654</span>
              </div>
            </div>

            {/* ================================scheme details============================ */}

            <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
              Transaction Details
            </div>

            <div className="row px-2">
              <div className="col-9 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">Scheme Name</span>
                <span className="fs-14px fw-500">
                  जलागम प्रबन्ध निदेशालय/राज्य स्तरीय स्प्रिंग एण्ड रिवर
                  रिजुविनेशन प्राधिकरण (सारा) ....
                </span>
              </div>
              <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">Scheme Code:</span>
                <span className="fs-14px fw-500">2401000012300</span>
              </div>
            </div>

            <div className="row px-2">
              <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">Grant Code:</span>
                <span className="fs-14px fw-500">1564</span>
              </div>
              <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">Scheme Type:</span>
                <span className="fs-14px fw-500">
                  State Capital Expenditure
                </span>
              </div>
              <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">
                  From Bal. of FY (Var):
                </span>
                <span className="fs-14px fw-500">2023-2024</span>
              </div>
              <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
                <span className="fs-12px text-black-60">Total Amount:</span>
                <span className="fs-14px fw-500">2023024</span>
              </div>
            </div>

            <div className="px-2 m-0 mt-1">
              <div className="border mb-2 mx-2"></div>

              <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                {!(cardClose === false && activeCard == 1) ? (
                  <button
                    onClick={() => {
                      setActiveCard(1);
                      setCardClose(false);
                    }}
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                      activeCard == 1 ? "bg-secondary-20" : "bg-white"
                    } `}
                  >
                    {activeCard == 1 ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub head
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      setActiveCard(0);
                      setCardClose(true);
                    }}
                    className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                      activeCard == 1 ? "bg-secondary-20" : "bg-white"
                    } `}
                  >
                    {activeCard == 1 ? (
                      <i className="icon-remove_circle_outline"></i>
                    ) : (
                      <i className="icon-add_circle_outline"></i>
                    )}
                    Sub head
                  </button>
                )}

                <>
                  {!(cardClose === false && activeCard == 2) ? (
                    <button
                      onClick={() => {
                        setActiveCard(2);
                        setCardClose(false);
                      }}
                      className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                        activeCard == 2 ? "bg-secondary-20" : "bg-white"
                      } `}
                    >
                      {activeCard == 2 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Activity
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setActiveCard(0);
                        setCardClose(true);
                      }}
                      className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                        activeCard == 2 ? "bg-secondary-20" : "bg-white"
                      } `}
                    >
                      {activeCard == 2 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Activity
                    </button>
                  )}

                  {!(cardClose === false && activeCard == 3) ? (
                    <button
                      onClick={() => {
                        setActiveCard(3);
                        setCardClose(false);
                      }}
                      className={` ${
                        activeCard == 3 ? "bg-secondary-20" : "bg-white"
                      } 
                        border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                    >
                      {activeCard == 3 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Sub-Activity
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setActiveCard(0);
                        setCardClose(true);
                      }}
                      className={` ${
                        activeCard == 3 ? "bg-secondary-20" : "bg-white"
                      } 
                        border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                    >
                      {activeCard == 3 ? (
                        <i className="icon-remove_circle_outline"></i>
                      ) : (
                        <i className="icon-add_circle_outline"></i>
                      )}
                      Sub-Activity
                    </button>
                  )}
                </>
              </div>

              {activeCard == 1 && (
                <>
                  <div className="border mx-2"></div>
                  <div className="row p-2 text-start">
                    <div className="col-5 d-flex flex-column">
                      <span className="fs-12px text-black-60">
                        {" "}
                        Subhead Code
                      </span>
                      <span className="fs-14px fw-600">-</span>
                    </div>

                    <div className="col d-flex flex-column">
                      <span className="fs-12px text-black-60"> Subhead</span>
                      <span className="fs-14px fw-600">-</span>
                    </div>

                    <div className="col d-flex flex-column">
                      <span className="fs-12px text-black-60">
                        Sanctioned Amount
                      </span>
                      <span className="fs-14px fw-600 ">-</span>
                    </div>
                  </div>
                </>
              )}
              {activeCard == 2 && (
                <>
                  <div className="border mx-2"></div>
                  <div className=" pb-2 d-flex flex-column gap-1 mt-2 mx-0 px-2">
                    <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                      <Accordion.Item
                        eventKey="10"
                        style={{ borderRadius: "0", border: "0" }}
                      >
                        <Accordion.Header
                          onClick={() => toggleAccordion("10")}
                          // style={{
                          //   display: "flex",
                          //   justifyContent: "space-between",
                          //   alignItems: "center",
                          //   position: "relative",
                          //   borderRadius: "0",
                          //   padding:"0"
                          // }}
                        >
                          <div className="w-100 d-flex justify-content-between">
                            <span>Subhead Name</span>
                            <span
                              className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                              style={{
                                height: "13.33px",
                                width: "13.33px",
                              }}
                            >
                              {activeKeys.includes("10") ? "-" : "+"}
                            </span>
                          </div>
                        </Accordion.Header>

                        <Accordion.Body>
                          <div>
                            {
                              <div className="row my-1 p-0 mx-0">
                                <div className="row p-2 text-start">
                                  <div className="col-5 d-flex flex-column">
                                    <span className="fs-12px text-black-60">
                                      {" "}
                                      Activity
                                    </span>
                                    <span className="fs-14px fw-600">-</span>
                                  </div>

                                  <div className="col d-flex flex-column">
                                    <span className="fs-12px text-black-60">
                                      {" "}
                                      Provisional
                                    </span>
                                    <span className="fs-14px fw-600">-</span>
                                  </div>

                                  <div className="col d-flex flex-column">
                                    <span className="fs-12px text-black-60">
                                      Released
                                    </span>
                                    <span className="fs-14px fw-600 ">-</span>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </>
              )}
            </div>

            <div className="row m-0 p-0 my-2">
              <span className="d-flex flex-column col-4">
                <span className="fs-12px text-prime-100">L1 Remark</span>
                <input
                  type="text"
                  placeholder="Data here"
                  className="fs-14px fw-500 border-top-0 border-start-0 border-end-0"
                />
              </span>
              <span className="d-flex flex-column col-4">
                <span className="fs-12px text-prime-100">L2 Remark</span>
                <input
                  type="text"
                  placeholder="Data here"
                  className="fs-14px fw-500 border-top-0 border-start-0 border-end-0"
                />
              </span>
              <span className="d-flex flex-column col-4">
                <span className="fs-12px text-prime-100">L3 Remark</span>
                <input
                  type="text"
                  placeholder="Data here"
                  className="fs-14px fw-500 border-top-0 border-start-0 border-end-0"
                />
              </span>
            </div>

          {/* ==========================Transaction details===================== */}

          <div className="m-0 p-0 text-secondary-100 fs-14px bg-prime-20 mt-2 p-1 fw-500">
            Scheme Details
          </div>

          <div className="row px-2">
            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
              <span className="fs-12px text-black-60">Transaction Date:</span>
              <span className="fs-14px fw-500">25/10/2025</span>
            </div>
            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
              <span className="fs-12px text-black-60">Transaction Time:</span>
              <span className="fs-14px fw-500">12:00:00:00</span>
            </div>
            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
              <span className="fs-12px text-black-60">Transaction No.:</span>
              <span className="fs-14px fw-500">1254125965</span>
            </div>
            <div className="col-3 m-0 p-0 d-flex gap-1 p-2 d-flex align-items-center">
              <span className="fs-12px text-black-60">PPA No.:</span>
              <span className="fs-14px fw-500">24158</span>
              <div className="d-flex gap-3 ms-2" >
              <i className="icon-payments text-danger-100"></i>
              <i className="icon-monetization_on_rupees text-prime-100"></i>
              </div>
            </div>
          </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PaymentHistroyOverlay;
